import React, { useState, useEffect } from 'react';
import { adminAPI } from '../../services/api';
import Navbar from '../../components/Navbar';

function Approvals() {
  const [pendingPartners, setPendingPartners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPendingApprovals();
  }, []);

  const fetchPendingApprovals = async () => {
    try {
      const response = await adminAPI.getPendingApprovals();
      setPendingPartners(response.data.data.pendingPartners);
    } catch (error) {
      console.error('Failed to fetch pending approvals:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleApproval = async (partnerId, isApproved) => {
    try {
      await adminAPI.updateApproval(partnerId, isApproved);
      alert(`Delivery partner ${isApproved ? 'approved' : 'rejected'} successfully!`);
      fetchPendingApprovals();
    } catch (error) {
      alert('Failed to update approval status');
    }
  };

  if (loading) return <div className="loading">🔄 Loading pending approvals...</div>;

  return (
    <div style={{ background: 'linear-gradient(135deg, #f5f7fa 0%, #e8eef3 100%)', minHeight: '100vh' }}>
      <Navbar />
      <div className="container">
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: 'var(--space-2xl)' }} className="fade-in">
          <h1 style={{
            fontSize: 'var(--font-size-4xl)',
            fontWeight: '800',
            background: 'var(--gradient-primary)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: 'var(--space-sm)'
          }}>
            ✅ Delivery Partner Approvals
          </h1>
          <p style={{ color: 'var(--gray-600)', fontSize: 'var(--font-size-lg)' }}>
            Review and approve delivery partner applications
          </p>
        </div>

        {pendingPartners.length === 0 ? (
          <div className="card fade-in" style={{ textAlign: 'center', padding: 'var(--space-2xl)' }}>
            <div style={{ fontSize: '120px', marginBottom: 'var(--space-lg)' }}>✅</div>
            <h2 style={{
              fontSize: 'var(--font-size-3xl)',
              fontWeight: '700',
              color: 'var(--gray-700)',
              marginBottom: 'var(--space-md)'
            }}>
              All caught up!
            </h2>
            <p style={{ color: 'var(--gray-600)', fontSize: 'var(--font-size-lg)' }}>
              No pending approvals at the moment
            </p>
          </div>
        ) : (
          <div style={{ display: 'grid', gap: 'var(--space-xl)' }}>
            {pendingPartners.map(partner => (
              <div key={partner._id} className="card fade-in" style={{
                position: 'relative',
                overflow: 'hidden'
              }}>
                {/* Pending Badge */}
                <div style={{
                  position: 'absolute',
                  top: 'var(--space-lg)',
                  right: 'var(--space-lg)',
                  padding: 'var(--space-sm) var(--space-lg)',
                  borderRadius: 'var(--radius-full)',
                  background: 'linear-gradient(135deg, #ffa500 0%, #ff8c00 100%)',
                  color: 'white',
                  fontWeight: '700',
                  fontSize: 'var(--font-size-xs)',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 'var(--space-xs)',
                  boxShadow: 'var(--shadow-md)'
                }}>
                  <span>⏳</span>
                  <span>Pending Review</span>
                </div>

                {/* Partner Header */}
                <div style={{ paddingRight: '180px', marginBottom: 'var(--space-lg)' }}>
                  <h2 style={{
                    fontSize: 'var(--font-size-3xl)',
                    fontWeight: '800',
                    color: 'var(--gray-900)',
                    marginBottom: 'var(--space-xs)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 'var(--space-sm)'
                  }}>
                    <span>🚴</span>
                    <span>{partner.name}</span>
                  </h2>
                  <p style={{
                    fontSize: 'var(--font-size-sm)',
                    color: 'var(--gray-600)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 'var(--space-xs)'
                  }}>
                    <span>📅</span>
                    <span>Registered: {new Date(partner.createdAt).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}</span>
                  </p>
                </div>

                {/* Partner Information */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                  gap: 'var(--space-lg)',
                  marginBottom: 'var(--space-xl)',
                  paddingBottom: 'var(--space-lg)',
                  borderBottom: '2px solid var(--gray-100)'
                }}>
                  {/* Contact Info */}
                  <div style={{
                    padding: 'var(--space-md)',
                    background: 'rgba(78, 205, 196, 0.1)',
                    borderRadius: 'var(--radius-md)',
                    border: '1px solid rgba(78, 205, 196, 0.2)'
                  }}>
                    <p style={{
                      fontSize: 'var(--font-size-xs)',
                      color: 'var(--gray-600)',
                      marginBottom: 'var(--space-xs)',
                      fontWeight: '600'
                    }}>
                      CONTACT INFORMATION
                    </p>
                    <p style={{
                      fontSize: 'var(--font-size-base)',
                      fontWeight: '700',
                      color: 'var(--secondary)',
                      margin: 0,
                      marginBottom: 'var(--space-xs)'
                    }}>
                      📧 {partner.email}
                    </p>
                    <p style={{
                      fontSize: 'var(--font-size-base)',
                      fontWeight: '700',
                      color: 'var(--secondary)',
                      margin: 0
                    }}>
                      📱 {partner.phone}
                    </p>
                  </div>

                  {/* Vehicle Details */}
                  <div style={{
                    padding: 'var(--space-md)',
                    background: 'rgba(255, 184, 77, 0.1)',
                    borderRadius: 'var(--radius-md)',
                    border: '1px solid rgba(255, 184, 77, 0.2)'
                  }}>
                    <p style={{
                      fontSize: 'var(--font-size-xs)',
                      color: 'var(--gray-600)',
                      marginBottom: 'var(--space-xs)',
                      fontWeight: '600'
                    }}>
                      VEHICLE DETAILS
                    </p>
                    <p style={{
                      fontSize: 'var(--font-size-base)',
                      fontWeight: '700',
                      color: 'var(--warning)',
                      margin: 0,
                      marginBottom: 'var(--space-xs)'
                    }}>
                      🛵 {partner.deliveryPartner?.vehicleType || 'N/A'}
                    </p>
                    <p style={{
                      fontSize: 'var(--font-size-sm)',
                      color: 'var(--gray-700)',
                      margin: 0
                    }}>
                      Plate: {partner.deliveryPartner?.vehicleNumber || 'N/A'}
                    </p>
                  </div>

                  {/* License Info */}
                  <div style={{
                    padding: 'var(--space-md)',
                    background: 'rgba(255, 107, 107, 0.1)',
                    borderRadius: 'var(--radius-md)',
                    border: '1px solid rgba(255, 107, 107, 0.2)'
                  }}>
                    <p style={{
                      fontSize: 'var(--font-size-xs)',
                      color: 'var(--gray-600)',
                      marginBottom: 'var(--space-xs)',
                      fontWeight: '600'
                    }}>
                      LICENSE INFORMATION
                    </p>
                    <p style={{
                      fontSize: 'var(--font-size-base)',
                      fontWeight: '700',
                      color: 'var(--primary)',
                      margin: 0
                    }}>
                      🪪 {partner.deliveryPartner?.licenseNumber || 'N/A'}
                    </p>
                  </div>
                </div>

                {/* Action Buttons */}
                <div style={{ display: 'flex', gap: 'var(--space-md)' }}>
                  <button
                    onClick={() => handleApproval(partner._id, true)}
                    className="btn btn-success btn-lg"
                    style={{
                      flex: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 'var(--space-sm)'
                    }}
                  >
                    <span>✅</span>
                    <span>Approve Partner</span>
                  </button>
                  <button
                    onClick={() => handleApproval(partner._id, false)}
                    className="btn btn-danger btn-lg"
                    style={{
                      flex: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 'var(--space-sm)'
                    }}
                  >
                    <span>❌</span>
                    <span>Reject Application</span>
                  </button>
                </div>

                {/* Hover Accent */}
                <div style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  width: '200px',
                  height: '200px',
                  background: 'radial-gradient(circle at bottom left, rgba(78, 205, 196, 0.1) 0%, transparent 70%)',
                  pointerEvents: 'none'
                }} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Approvals;
